import script from "./PandoraFooter2.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraFooter2.vue?vue&type=script&setup=true&lang=js"

import "./PandoraFooter2.vue?vue&type=style&index=0&id=7b5ef02d&lang=css"

const __exports__ = script;

export default __exports__